import LayerProdStateDot from "@/v2-backoffice-client/layer/authoring/LayerProdStateDot"
import { useLayerAuthoringStatusMap } from "@/v2-backoffice-client/layer/authoring/layer.authoring.status.query"

export type LayerProdStateCellProps = {
  featureCode: string
}

/**
 * Table cell for the production chip. Reads the shared statuses query
 * (one round trip, cached by Apollo) so each row is a plain map lookup.
 */
function LayerProdStateCell(props: LayerProdStateCellProps) {
  const { featureCode } = props
  const statuses = useLayerAuthoringStatusMap()
  return <LayerProdStateDot status={statuses.get(featureCode)} />
}

export default LayerProdStateCell
